var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect20, _rect21, _rect22, _path9, _rect23, _rect24, _rect25, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 353,
    viewBox: "0 0 631 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 46.9761,
    transform: "matrix(4.37725e-10 -1 0.999984 0.00573743 183.475 130.228)",
    fill: "url(#paint0_linear_405_1443)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 46.9762,
    transform: "matrix(0 -1 -0.999984 0.00573743 445.128 130.228)",
    fill: "url(#paint1_linear_405_1443)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.80153,
    height: 66.5992,
    transform: "matrix(-0.926384 0.376565 0.364432 0.931269 194.258 264.396)",
    fill: "url(#paint2_linear_405_1443)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.80161,
    height: 66.6005,
    transform: "matrix(0.923603 0.383366 -0.371132 0.928542 435.719 265.286)",
    fill: "url(#paint3_linear_405_1443)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 50.1352,
    transform: "matrix(1 9.25555e-10 -0.00561531 0.999984 315.011 27.4238)",
    fill: "url(#paint4_linear_405_1443)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.5391,
    transform: "matrix(-0.00360657 0.999994 -0.999956 -0.00942233 222.958 285.586)",
    fill: "url(#paint5_linear_405_1443)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.5391,
    transform: "matrix(-0.00360648 0.999994 0.999998 -0.00205253 407.192 286.265)",
    fill: "url(#paint6_linear_405_1443)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 60.1227,
    transform: "matrix(-0.00360648 0.999994 0.999998 -0.00205253 186.803 350.714)",
    fill: "url(#paint7_linear_405_1443)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 60.1227,
    transform: "matrix(-0.00360657 0.999994 -0.999956 -0.00942233 442.809 350.657)",
    fill: "url(#paint8_linear_405_1443)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.5926,
    transform: "matrix(-0.00360657 0.999994 -0.999956 -0.00942233 222.917 296.625)",
    fill: "url(#paint9_linear_405_1443)",
    fillOpacity: 0.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.5925,
    transform: "matrix(-0.00360648 0.999994 0.999998 -0.00205253 407.152 297.304)",
    fill: "url(#paint10_linear_405_1443)",
    fillOpacity: 0.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 11.646,
    transform: "matrix(-0.00360657 0.999994 -0.999956 -0.00942233 222.878 307.625)",
    fill: "url(#paint11_linear_405_1443)",
    fillOpacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 11.646,
    transform: "matrix(-0.00360648 0.999994 0.999998 -0.00205253 407.112 308.304)",
    fill: "url(#paint12_linear_405_1443)",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9786,
    height: 6,
    transform: "matrix(0.999993 0.00368496 0.00360653 -0.999994 290.564 255.751)",
    fill: "url(#paint13_linear_405_1443)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9786,
    height: 6,
    transform: "matrix(0.999993 0.00368496 -0.00360653 0.999994 290.539 262.751)",
    fill: "url(#paint14_linear_405_1443)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9786,
    height: 10,
    transform: "matrix(0.999993 0.00368496 0.00360653 -0.999994 314.307 255.838)",
    fill: "url(#paint15_linear_405_1443)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9786,
    height: 10,
    transform: "matrix(0.999993 0.00368496 -0.00360653 0.999994 314.282 262.838)",
    fill: "url(#paint16_linear_405_1443)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9786,
    height: 6,
    transform: "matrix(0.999993 0.00368496 0.00360653 -0.999994 336.072 255.918)",
    fill: "url(#paint17_linear_405_1443)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9786,
    height: 6,
    transform: "matrix(0.999993 0.00368496 -0.00360653 0.999994 336.046 262.918)",
    fill: "url(#paint18_linear_405_1443)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.55 217.985L338.033 132.04C337.96 130.847 338.718 128.638 342.331 129.354L512.229 129.354C513.976 128.981 518.13 129.534 520.766 134.726L564.209 195.156C565.547 197.021 569.032 200.751 572.268 200.751L628.663 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.808 218.209L293.292 132.183C293.378 130.988 292.644 128.777 289.02 129.494L118.986 129.494C117.242 129.121 113.079 129.674 110.383 134.872L66.2251 195.373C64.8651 197.24 61.3354 200.975 58.0966 200.975L1.65688 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M292.259 316.911L292.219 324.073C292.293 325.117 291.821 327.206 289.346 327.206L220.102 327.206C219.468 327.206 217.73 325.953 215.854 320.94C215.442 319.838 213.505 315.017 210.558 307.735M1.53985 221.79L21.4089 221.79M137.471 189.784L137.451 193.365L137.493 185.979M137.471 189.784L148.715 189.784M137.471 189.784L126.228 189.784M148.715 189.784L159.958 189.784C162.052 189.784 163.514 192.172 163.983 193.365C174.078 218.091 190.521 258.404 202.203 287.144M148.715 189.784L148.695 193.365L148.736 185.979M126.228 189.784L114.985 189.784C113.558 189.635 110.033 190.142 107.35 193.365L96.9296 205.787M126.228 189.784L126.208 193.365L126.25 185.979M96.9296 205.787L86.509 218.209C85.3125 219.402 82.5388 221.79 81.0159 221.79L61.1469 221.79M96.9296 205.787L107.281 205.787L86.5787 205.787M41.2779 221.79L41.2515 226.49M41.2779 221.79L61.1469 221.79M41.2779 221.79L21.4089 221.79M61.1469 221.79L61.1205 226.49M21.4089 221.79L21.3825 226.49M210.558 307.735L222.115 307.735M210.558 307.735C209.33 304.7 207.926 301.238 206.385 297.439M206.385 297.439L222.173 297.439M206.385 297.439C205.082 294.229 203.68 290.779 202.203 287.144M202.203 287.144L222.231 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M337.003 316.911L336.963 324.073C336.878 325.117 337.326 327.206 339.801 327.206L409.045 327.206C409.679 327.206 411.431 325.953 413.363 320.94C413.787 319.838 415.779 315.017 418.807 307.735M628.791 221.79L608.922 221.79M493.219 189.784L493.199 193.365L493.24 185.979M493.219 189.784L481.976 189.784M493.219 189.784L504.462 189.784M481.976 189.784L470.732 189.784C468.638 189.784 467.15 192.172 466.667 193.365C456.294 218.091 439.399 258.404 427.394 287.144M481.976 189.784L481.955 193.365L481.997 185.979M504.462 189.784L515.705 189.784C517.134 189.635 520.653 190.142 523.3 193.365L533.581 205.787M504.462 189.784L504.442 193.365L504.483 185.979M533.581 205.787L543.862 218.209C545.045 219.402 547.792 221.79 549.315 221.79L569.184 221.79M533.581 205.787L523.23 205.787L543.932 205.787M589.053 221.79L589.026 226.49M589.053 221.79L569.184 221.79M589.053 221.79L608.922 221.79M569.184 221.79L569.157 226.49M608.922 221.79L608.895 226.49M418.807 307.735L407.25 307.735M418.807 307.735C420.07 304.7 421.512 301.238 423.096 297.439M423.096 297.439L407.308 297.439M423.096 297.439C424.435 294.229 425.876 290.779 427.394 287.144M427.394 287.144L407.366 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.749 201.87L316.745 24.6092C316.749 23.8631 317.233 22.371 319.137 22.371L519.255 22.371C521.475 22.4456 525.921 21.8339 525.938 18.79C525.955 15.7461 526 7.6739 526.021 4.01826C525.946 3.12301 526.369 1.33249 528.653 1.33249L619.62 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.247 201.87L315.745 113.24L316.243 24.6092C316.247 23.8631 315.78 22.371 313.879 22.371L114.066 22.371C111.848 22.4456 115.421 21.6537 115.438 18.6099C115.455 15.566 115.5 7.49375 115.521 3.83812C115.605 2.94286 107.199 1.33249 104.918 1.33249L11.7089 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M315.006 337.726L314.961 345.783C314.791 347.723 315.499 351.602 319.687 351.602L492.679 351.602C493.947 351.751 497.394 350.886 501.037 346.231L558.075 274.162C559.113 272.894 561.618 270.357 563.331 270.357L628.292 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.015 337.726L313.97 345.783C314.118 347.723 313.366 351.602 309.178 351.602L136.187 351.602C134.917 351.751 131.479 350.886 127.889 346.231L71.6605 274.162C70.6365 272.894 68.1602 270.357 66.4469 270.357L1.48592 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 532.816 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 3.13428 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 614.189 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 599.425 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 584.66 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M569.891 193.664C569.894 193.252 570.23 192.918 570.642 192.918L578.85 192.918C579.954 192.918 580.845 193.813 580.839 194.918L580.835 195.568C580.829 196.577 580.007 197.394 578.999 197.394L573.601 197.394C571.54 197.394 569.88 195.724 569.891 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 16.9424 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 31.707 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 46.4717 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2321 193.664C61.2345 193.252 60.9023 192.918 60.4903 192.918L52.2821 192.918C51.1775 192.918 50.277 193.813 50.2708 194.918L50.2672 195.568C50.2615 196.577 51.0743 197.394 52.0826 197.394L57.4809 197.394C59.5411 197.394 61.2206 195.724 61.2321 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 46.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 46.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_405_1443",
    x1: 0.900764,
    y1: 0,
    x2: 0.900764,
    y2: 66.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_405_1443",
    x1: 0.900803,
    y1: 0,
    x2: 0.900803,
    y2: 66.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_405_1443",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 60.1227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 60.1227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.5926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.5925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 11.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_405_1443",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 11.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_405_1443",
    x1: 0.9893,
    y1: 6,
    x2: 0.9893,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_405_1443",
    x1: 0.9893,
    y1: 6,
    x2: 0.9893,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_405_1443",
    x1: 0.9893,
    y1: 10,
    x2: 0.9893,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_405_1443",
    x1: 0.9893,
    y1: 10,
    x2: 0.9893,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_405_1443",
    x1: 0.9893,
    y1: 6,
    x2: 0.9893,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_405_1443",
    x1: 0.9893,
    y1: 6,
    x2: 0.9893,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame8);
export default __webpack_public_path__ + "static/media/card1-frame8.1d45181994a6f2883c9df4e799d08125.svg";
export { ForwardRef as ReactComponent };